import * as Yup from 'yup';
import { get } from 'lodash';
import { trims } from 'utils';

Yup.addMethod(Yup.string, 'uniqueField', function (parent: string) {
  // @ts-ignore
  return this.test('uniqueField', parent, function (obj: string) {
    // @ts-ignore
    const { value } = this.from[1];
    const list = get(value, parent);
    const fieldName = this.path.split('.')[1];

    const uniqValues = [] as any[];
    const doubles = [] as any[];

    if (parent === 'locations' || parent === 'SMCs') {
      list.forEach((doc: any) => {
        const val = trims(String(doc.name).toLocaleLowerCase());

        if (uniqValues.includes(val) && !doubles.includes(val)) {
          doubles.push(val);
        }
        if (!uniqValues.includes(val)) {
          uniqValues.push(val);
        }
      });
    } else {
      list.forEach((doc: any) => {
        const val = trims(String(doc[fieldName]).toLocaleLowerCase());

        if (uniqValues.includes(val) && !doubles.includes(val)) {
          doubles.push(val);
        }
        if (!uniqValues.includes(val)) {
          uniqValues.push(val);
        }
      });
    }

    if (!doubles.includes(obj)) return true;

    return this.createError({
      path: this.path,
      message: 'Вже є у списку',
    });
  });
});

const settingsSchema = Yup.object().shape({
  id: Yup.number(),
  messageText: Yup.string(),
  aadRoles: Yup.array().of(
    Yup.object().shape({
      id: Yup.number(),
      roleId: Yup.number().required(),
      title: Yup.string().nullable().required(),
      objectId: Yup.string()
        .nullable()
        .length(36, 'Має містити 36 символів')
        .matches(
          /^([0-9A-Fa-f]{8}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{4}[-][0-9A-Fa-f]{12})$/,
          'Має містити лише числа та букви від A(a) до F(f)',
        )
        .required("Обов'язкове поле") // @ts-ignore
        .uniqueField('aadRoles'),
    }),
  ),
});

export default settingsSchema;
